var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#pattern0_311_273)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_311_273",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_311_273",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_311_273",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADtUlEQVR4nO2cz0sVURTHb5C2sMKkX5RFULSoVT+QpEURRH9CheCmgn4uSkG0AhcpgquiTWuzggp3lf2m2kRE28qWldVKd2nmJy7e4DXMezn65s65M+cDg+89zz3vnPnOu3N/zL3GKIqiKIqiKIqiKIqiKIqiKIqiKIqSEGAF0A48B74CU4THlIv9GdAGLDfSARa4Ez9O/hgHztkcjUSAhcAt8s9Nm6uRBnCV4nDZSALYQ/HYZ6QAvKJ4vDASANYC0xSPaaBRggCHKS4HJQhgm51FpU2CAN0Ul+6sz78KkDUqQMaoABmjAmSMCpAxKoB8AYaBfqAvsKPfxR60AC0mcICWUAUYNjkBeBiiAL0mJwC9IQqQfXBFyDHN4Ji58iZKfNrXPb7tiyzARIzfn77tiyxALL7tVYAIvu2LLMBEjF+tgnwFB/TE3CQv+bYvrABSEJ2j6OCKkKPo4IqQo+jgipBjkuCATe4xlg53tNvPKvgWYZ8nAT7F2H2s4FuEfZ4EiMWU9y3CXgXI2F4FyNg+TwKMJKyjRyTY50kA2+q4WDLxfQHYWMG3CHugFbjtVgH1ub/2favJGtFXRxFQATJGBcgYFSCsm7CISfbZAqwGjgFDtnVUsgB93L0fcv9fZQIRQMQM1/8AdrrHEn8zO6zdA2CH8U3IHbEodj8It9p/rqs+bblBoMH4Ii8CAJuB91QHO8i31fggD1UQ0JzCBiPWX7MRJoCISfZSgPXAN9JhFFhn0iTkZihQC7xLcEI7gTqgK0GZt0BNmkmELMAZklHryi1KWO5UmkkEKQCwOGnVEymfhB/A0rQSsdt5xXHN5OvqJ1IeEb8C4FCZL7T7rS0zQgGeeBbgUVqJNFbouLwGdv+tO6UANAC/PAswCdSnldBLZNMUiffAXJzMUwDL/rQE2ItsNkTiPVlhTGeg3NLViI9yy1sHKtQIx1MRwAV0BbnURWK17fk4Bqp0Lq6X8d9ZDf+Vtq28gUzqci9AycatZ4ExwqyCpt3J64g7Ij5ibdxoqP8qKGZY1+4y+xT4ImDr4qZc34RDA6h3zUKfAkxK7hd5B3jsWYDcbN1QFXIzFBEqzAzGjXoS4DuwJLtshQKc9jQcfSLrXEUC1LgJk9nS5X455xOUeZPqhEzoAGuAz4Q6JZkHSGdS3nZGd2WdWzBQ/cdStmSdU3AwM08wmOCJuHKjqdrhmg/AduB+AiHsUMs9YNu8vlj5F2AlcBS4C3woGWQcc9XVHeCItYsUVRRFURRFUUwl/gDeelU8kGGvZQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservations);
export default __webpack_public_path__ + "static/media/reservations.b9d05186584638606828d3d9122d190c.svg";
export { ForwardRef as ReactComponent };